import React, { useContext, useEffect, useState } from "react";
import GlobalStylesContext, {
  IGlobalStylesContext,
} from "~/styles/context/global-styles.context";
import { FontEnum, ITheme } from "~/styles/theme.type";
import RootStyles from "./root-styles";
import { getFontFamily } from "@commons-monorepo/index";

type Props = {
  children: React.ReactNode;
  theme: ITheme;
  setFont: (font: FontEnum) => void;
};

export function GlobalStylesWrapper({ children, theme, setFont }: Props) {
  const [customTheme, setTheme] = useState(theme);
  const [storeInformationInView, setStoreInformationInView] = useState(true);

  useEffect(() => {
    setTheme((prev) => ({
      ...prev,
      fontFamily: theme.fontFamily,
    }));
  }, [theme.fontFamily]);

  const handleStoreInformationInView = (value: boolean) => {
    setStoreInformationInView(value);
  };

  const value = {
    theme: customTheme,
    setTheme,
    setFont,
    storeInformationInView,
    setStoreInformationInView: handleStoreInformationInView,
  };

  return (
    <GlobalStylesContext.Provider value={value}>
      <RootStyles
        themeColors={customTheme.themeColors}
        fontFamily={getFontFamily(customTheme.fontFamily)}
      />
      {children}
    </GlobalStylesContext.Provider>
  );
}

export function useGlobalStyles(): IGlobalStylesContext {
  const context = useContext(GlobalStylesContext);
  if (context === undefined) {
    throw new Error("Context must be used within a Provider");
  }
  return context;
}
